import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard";
import "./App.css";
import MyTasks from "./features/MyTasks/MyTasks";
import ViewTask from "./components/MyTasks/ViewTask/ViewTask";
import Incidents from "./features/Incidents/Incidents";
import IncidentDetails from "./components/Incidents/IncidentDetails/IncidentDetails";
import NewIncident from "./components/Incidents/NewIncident/NewIncident";
import TaskLibrary from "./features/TaskLibrary/TaskLibrary";
import TaskAutomation from "./features/TaskAutomation/TaskAutomation";
import LoginPage from "./pages/LoginPage/LoginPage";
import RequireAuth from "./features/auth/RequireAuth";
import PrivateRoute from "./features/auth/PrivateRoutes";
import ManageUsers from "./features/ManageUsers/ManageUsers";
import ReleaseNotes from "./pages/ReleaseNotes/ReleaseNotes";
import ReleaseNotesLayout from "./pages/ReleaseNotes/ReleaseNotesLayout";
import ReleaseNote from "./pages/ReleaseNotes/ReleaseNote";

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route path="/" element={<Dashboard />}>
          <Route index element={<Navigate to="my-tasks" />} />
          <Route path="my-tasks" element={<MyTasks />} />
          <Route path="my-tasks/view/:taskId" element={<ViewTask />} />
          <Route path="incidents" element={<Incidents />} />
          <Route
            path="incidents/view/:incidentId/:taskTab?"
            element={<IncidentDetails />}
          />
          <Route
            path="incidents/new/:id?/:group?/:type?/:subType?/:formType?"
            element={<NewIncident />}
          />
          <Route element={<PrivateRoute />}>
            <Route path="admin">
              <Route index element={<Navigate to="manage-users" />} />
              <Route path="manage-users" element={<ManageUsers />} />
              <Route path="task-library" element={<TaskLibrary />} />
              <Route path="incident-tasks" element={<TaskAutomation />} />
            </Route>
          </Route>
          {/* <Route path="faq" element={<h1>Help/FAQ</h1>} /> */}
        </Route>
      </Route>
      <Route path="/release-notes" element={<ReleaseNotesLayout />}>
        <Route index element={<ReleaseNotes />} />
        <Route path=":id" element={<ReleaseNote />} />
      </Route>
    </Routes>
  );
}

export default App;
